<template>
    <ul class="igc-notice"
        :style="{ 'background': mColor(7) }">
        <template v-for="(item, index) in noticeList">
            <li v-if="index == 0"
                :key="item.iId"
                @click="to(item.iId)">
                <div class="ig--info">
                    <div class="ig--title" :style="{ 'color': mColor(1) }">{{ item.sTitle }}</div>
                    <div class="ig--desc" :style="{ 'color': mColor(3) }">
                        <router-link class="ig--label" :style="{ 'background': mColor(10) }"
                            :to="{ name: 'notice', query: { id: notice.id, name: notice.name } }"
                            @click.native.stop>
                            <span :style="{ 'color': mColor(2.1) }">公告</span>
                        </router-link>
                        <span>{{ noticeList[0].sIdxTime | mcFormatTime('M月D日') }}</span>
                    </div>
                </div>
                <sui-image :src="mImageView(item.sIMG, '/1/w/315/h/210')"></sui-image>
            </li>
            <li class="ig--mini" :style="{ 'background': mBackground(8.1, 'top') }"
                v-if="index > 0"
                :key="item.iId"
                @click="to(item.iId)">
                <div class="ig--title ig-style--ellipsis"
                    :style="{ 'color': mColor(1) }">{{ item.sTitle }}</div>
                <div class="ig--time"
                    :style="{ 'color': mColor(3) }">{{ item.sIdxTime | mcFormatTime('M月D日') }}</div>
            </li>
        </template>
    </ul>
</template>

<script>
import { requestV4MixedList } from '../../scripts/request'

import mCore from '../../scripts/mixins/core'

export default {
    name: 'igc-notice',
    
    mixins: [mCore],

    props: {
        notice: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            noticeList: []
        }
    },

    mounted() {
        requestV4MixedList({
            limit: this.notice.num,
            start: 0,
            tagids: this.notice.id,
        }).then((result) => {
            const { data = {} } = result
            if (data.status == 0) {
                this.noticeList = data.data.items || []
            }
        })
    },

    methods: {

        /**
         * 详情页跳转
         * @param {String} id - 资讯 id
         */
        to(id) {
            this.mEventTracking('list_notice', '列表_公告', {
                id
            })
            this.$router.push({
                name: 'detail-news',
                params: {
                    id
                }
            })
        }
    }
}
</script>

<style lang="postcss">
.igc-notice {
    overflow: hidden;
    width: 680px;
    height: 322px;
    margin-top: 20px;
    @media (orientation: portrait) {
        width: 100%;
    }
    @media (orientation: landscape) {
        width: calc((100% - 20px) / 2);
    }
    li {
        display: flex;
        padding: 20px;
        .ig--info {
            flex: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            overflow: hidden;
            .ig--title {
                display: -webkit-box;
                /* autoprefixer: ignore next */
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                font-size: 32px;
            }
            .ig--desc {
                display: flex;
                align-items: center;
                font-size: 24px;
                .ig--label {
                    display: flex;
                    align-items: center;
                    margin-top: 0;
                    height: 34px;
                    border-radius: 17px;
                    margin-right: 20px;
                    padding: 0 12px;
                    font-size: 11px;
                }
                span{
                    font-size:16px;
                }
            }
        }
        .sui-image {
            flex: none;
            width: 210px;
            height: 140px;
            margin-left: 20px;
        }
    }
    .ig--mini {
        align-items: center;
        box-sizing: border-box;
        overflow: hidden;
        height: 71px;
        padding: 0 24px;
        font-size: 26px;
        .ig--title {
            flex: auto;
        }
        .ig--time {
            flex: none;
            margin-left: 20px;
        }
    }
}
</style>
